import { useEffect } from 'react';
import { useHistory } from 'react-router';

const useBackIf = (condition) => {
  const history = useHistory();

  useEffect(() => {
    if (condition === true) history.goBack();
  }, [condition, history]);
};

export default useBackIf;
